<form class="pmd-form-card forgotpassword-section"
    *ngIf="forgotFirstStep"
    [formGroup]="forgotForm"
    (ngSubmit)="forgotPasswordSubmit()">
    <pmd-alert type="danger"
        *ngIf="errorMessageForgotPass">
        {{ errorMessageForgotPass }}
    </pmd-alert>
    <div class="mb-4">
        <h2 class="card-title">Forgot Password?</h2>
        <p class="card-subtitle">Please enter the email id or mobile number associated with your account.</p>
    </div>


    <div [ngClass]="sharedService.pmdStatusClass(f.username, isSubmitAttempted)">
        <label for="Username"
            class="col-form-label">Email ID or Mobile Number</label>
        <pmd-textfield pmd-textfield-outline>
            <input type="text"
                formControlName="username"
                class="form-control"
                [ngClass]="sharedService.pmdStatusClass(f.username, isSubmitAttempted)"
                pmdTextField>
        </pmd-textfield>
        <div *ngIf="f.username.hasError('required') && f.username.touched"
            class="invalid-feedback">
            Please enter a valid email id or mobile number.
        </div>
        <div *ngIf="f.username.hasError('pattern') && f.username.touched"
            class="invalid-feedback">
            Please enter a valid email id or mobile number.
        </div>
    </div>
    <div class="mt-3">
        <button type="submit"
            [disabled]="!forgotForm.valid"
            [attr.aria-disabled]="!forgotForm.valid"
            pmdRipple
            pmd-btn-raised
            color="secondary">Send Request</button>
        <p class="mt-3 mb-3">Remember Password? <a routerLink="/login"
                class="link-text">Sign In</a></p>
    </div>
</form>

<form [formGroup]="otpSectionForm"
    *ngIf="forgotOtpSection"
    (ngSubmit)="otpSubmit()">
    <div id="otpFieldscreen">
        <div class="mb-4">
            <h1 class="h2 card-title">Enter 6 digit recovery code</h1>
            <p class="card-subtitle">The recovery code has been sent to your mobile number. Please
                enter the code to verify your account</p>
        </div>
        <pmd-alert type="danger"
            *ngIf="errorMessageVerify">
            {{ errorMessageVerify }}
        </pmd-alert>
        <pmd-alert type="success"
            *ngIf="successMsgOtpSection">
            {{ successMsgOtpSection }}
        </pmd-alert>
        <div class="d-flex gap-3 justify-content-center khr-forgot-pw">
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count1, isSubmitAttempted)">
                <input #count1Input
                    (input)="moveFocus(count1Input, count2Input,null); onInputChange()"
                    id="count1"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count1, isSubmitAttempted)"
                    formControlName="count1"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count2, isSubmitAttempted)">
                <input #count2Input
                    (input)="moveFocus(count2Input, count3Input,count1Input); onInputChange()"
                    id="count2"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count2, isSubmitAttempted)"
                    formControlName="count2"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count3, isSubmitAttempted)">
                <input #count3Input
                    (input)="moveFocus(count3Input, count4Input,count2Input); onInputChange()"
                    id="count3"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count3, isSubmitAttempted)"
                    formControlName="count3"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count4, isSubmitAttempted)">
                <input #count4Input
                    (input)="moveFocus(count4Input, count5Input,count3Input); onInputChange()"
                    id="count4"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count4, isSubmitAttempted)"
                    formControlName="count4"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count5, isSubmitAttempted)">
                <input #count5Input
                    (input)="moveFocus(count5Input, count6Input,count4Input); onInputChange()"
                    id="count5"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count5, isSubmitAttempted)"
                    formControlName="count5"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline
                [ngClass]="sharedService.pmdStatusClass(verifyf.count6, isSubmitAttempted)">
                <input #count6Input
                    (input)="moveFocus(count6Input, count6Input,count5Input); onInputChange()"
                    id="count6"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count6, isSubmitAttempted)"
                    formControlName="count6"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>

        </div>
        <div class="d-flex mt-3"
            [class.disabled-section]="disableResendButton">
            <p class="mb-0">
                <a href="javascript:void(0);"
                    (click)="reSendCodeSubmit();"
                    [class.disabled-link]="disableResendButton">Resend code</a>
            </p>
            <span class="ms-auto">{{ time }}</span>
        </div>

        <div class="mt-4">
            <button pmdRipple
                [disabled]="!otpSectionForm.valid || disableButtonOnError"
                [attr.aria-disabled]="!otpSectionForm.valid || disableButtonOnError"
                type="submit"
                pmd-btn-raised
                color="secondary">Verify Code</button>
            <p class="mt-3 mb-0"
                class="link-text mt-3">
                <span [pmdPopover]="popTemplate"
                    container="body"
                    placement="bottom"
                    containerClass="turnOverPopUp pmd-card mb-1"
                    class="py-2">Did not receive the verification code?</span>
            </p>
            <ng-template #popTemplate>
                <div class="verification-code">
                    <div class="title-info">If you have not received a verification code on your email id or your mobile
                        number:</div>
                    <ul class="list-group pmd-list mb-3">
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">email</span>
                            <span>Check your email inbox spam folder.</span>
                        </li>
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">refresh</span>
                            <span>Try "Resend code" option above.</span>
                        </li>
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">check</span>
                            <span>Please check if you have entered a correct email id and mobile number.</span>
                        </li>
                    </ul>
                    <p>For any further assistance please contact our support team at <a
                            href="mailto:support@kharchaapp.com"
                            target="_blank">[support@purchaseapp.com]</a>.</p>
                </div>
            </ng-template>
        </div>
    </div>
</form>

<form [formGroup]="resetPasswordForm"
    (ngSubmit)="resetPasswordSubmit()"
    *ngIf="passwordSection">
    <pmd-alert type="danger"
        *ngIf="errorMessageForgotPass">
        {{ errorMessageForgotPass }}
    </pmd-alert>
    <div class="pmd-card-focus pf-section-up mt-2 mb-4"
        tabindex="-1">
        <div tabindex="-1">
            <div class="mb-4">
                <h1 class="h2 card-title">{{otp ? 'Create a new password' : 'Setup your password'}}</h1>
                <p class="card-subtitle">
                    {{ otp ?
                    'Please choose a new password that is secured. Your new password must be different from previously
                    used password.' : 'Please choose a new passoword that is secured.'}}

                </p>
            </div>
            <div class="mb-3"
                [ngClass]="sharedService.pmdStatusClass(resetPass.password, isSubmitAttempted)">
                <div [ngClass]="sharedService.pmdStatusClass(resetPass.password, isSubmitAttempted)">
                    <label for="Password2"
                        class="col-form-label">Password <span class="text-danger"
                            aria-label="required">*</span></label>
                    <pmd-textfield pmd-textfield-outline
                        class="position-relative">
                        <input pmdTextField
                            #passwordInput
                            [type]="isPasswordVisible ? 'text' : 'password'"
                            maxlength="25"
                            [ngClass]="sharedService.pmdStatusClass(resetPass.password, isSubmitAttempted)"
                            formControlName="password"
                            class="form-control"
                            aria-label="Password2"
                            aria-describedby="Password2">
                        <i class="material-symbols-outlined md-dark pmd-icon-sm pf-cursor-pointer visibility-icon"
                            (click)="togglePasswordVisibility()">{{ isPasswordVisible ? 'visibility_off' : 'visibility'
                            }}
                        </i>
                    </pmd-textfield>

                </div>

                <div *ngIf="sharedService.hasErrors(resetPass.password, isSubmitAttempted)"
                    class="invalid-feedback">
                    <ng-container *ngIf="resetPass.password.errors.required || resetPass.password.errors.minlength">
                        Please provide a valid password.
                    </ng-container>
                </div>
            </div>
            <ul class="pf-pass-valid-list list-group pmd-list mb-4">
                <li class="pf-pass-valid-item"
                    [class.valid-point]="isRequirementMet(appGlobals.regex.lowerCase)">
                    One lowercase character
                </li>
                <li class="pf-pass-valid-item"
                    [class.valid-point]="isRequirementMet(appGlobals.regex.upperCase)">
                    One uppercase character
                </li>
                <li class="pf-pass-valid-item"
                    [class.valid-point]="isRequirementMet(appGlobals.regex.symbol)">
                    One special character
                </li>
                <li class="pf-pass-valid-item"
                    [class.valid-point]="isRequirementMet(appGlobals.regex.length(8))">
                    8 characters minimum
                </li>
                <li class="pf-pass-valid-item"
                    [class.valid-point]="isRequirementMet(appGlobals.regex.number)">
                    One number
                </li>
            </ul>
            <div class="">
                <button type="submit"
                    [disabled]="!resetPasswordForm.valid"
                    [attr.aria-disabled]="!resetPasswordForm.valid"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary">{{otp ? 'Reset': 'Create' }} Password</button>
            </div>
        </div>
    </div>
</form>
<div class="reset-message mb-4"
    *ngIf="successPasswordMessage">
    <div class="pmd-card-icon">
        <i class="material-symbols-outlined pmd-icon-primary pmd-icon-circle pmd-icon-md">check</i>
    </div>
    <h3 pmd-card-title
        class="mb-2">Password {{otp ? 'Reset' : 'Setup'}} Successfully!</h3>
    <p pmd-card-subtitle>Your password has been {{otp ? 'Reset' : 'setup'}} successfully. Please login with your new
        password</p>
    <div>
        <a routerLink="/login"
            class="me-2 mt-4"
            pmdRipple
            pmd-btn-raised
            color="secondary">Sign In Now</a>
    </div>
</div>